import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PhoneIcon } from '@heroicons/react/24/solid';
import { useLanguage } from '../contexts/LanguageContext';
import { localizedPath, findRouteByPath } from '../seo/routes';

const EmergencyButton: React.FC = () => {
  const { translations, language } = useLanguage();
  const location = useLocation();

  // Die Notfall-Spoke-Seiten (Zahnschmerzen/Abszess/abgebrochener Zahn/Touristen)
  // haben mobil bereits eine eigene volle Anruf-/WhatsApp-Leiste am unteren Rand
  // (EmergencySpokePage.tsx). Diese schwebende Pille würde sich dort mit der
  // Leiste überlagern — auf Mobilgeräten deshalb dort ausblenden, auf Desktop
  // und allen übrigen Seiten unverändert anzeigen.
  const routeKey = findRouteByPath(location.pathname)?.key;
  const hidesOnMobile = !!routeKey && routeKey.startsWith('emergency-');

  return (
    <div className={`fixed bottom-4 right-4 z-50 ${hidesOnMobile ? 'hidden md:flex' : 'flex'} flex-col items-end space-y-2`}>
      <div className="transform transition-transform duration-300 hover:scale-105">
        <a 
          href="tel:603319648" 
          className="flex items-center justify-center bg-coral text-white hover:bg-coral/90 py-2.5 px-4 rounded-full shadow-lg border-2 border-white animate-emergencyPulse"
          aria-label="Call emergency service"
        >
          <PhoneIcon className="w-5 h-5 mr-1.5" aria-hidden="true" />
          <span className="font-bold">603 31 96 48</span>
        </a>
      </div>
      <Link
        to={localizedPath('emergency', language)}
        className="text-xs bg-white text-coral px-3 py-1 rounded-full shadow-md hover:bg-gray-100 font-semibold"
      >
        {translations.nav.emergency}
      </Link>
    </div>
  );
};

export default EmergencyButton; 